/*global angular*/
(function () {
    'use strict';

    angular.module('resortApp').constant('resortImages', {
        baseUrl: 'https://resortimages.s3.us-east-2.amazonaws.com'
    });

}());
